module.exports = __webpack_public_path__ + "media/Loops 90 Perc.9c4c0ee6.wav";